<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Sales Executives"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="SalesExecutives"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Sales Executives</div>
      </template>

      <template #empty> No Related Job Sales Executives found! </template>
      <template #loading>
        Loading Related Sales Executives. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="salesExecCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.salesExecCode ? slotProps.data.salesExecCode : "" }}
        </template>
      </Column>
      <Column field="salesExecName" header="Name" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.salesExecName ? slotProps.data.salesExecName : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editSalesExecutives(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="SalesExecutivesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Sales Executives"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="user">User</label>
          <Dropdown
            v-model="user"
            :showClear="true"
            :options="users"
            dataKey="id"
            optionLabel="fullName"
            placeholder="Select User"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="SalesExecutive.salesExecCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Name:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="SalesExecutive.salesExecName"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="SalesExecutive.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="SalesExecutivesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Sales Executives?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteSalesExecutive"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { settingFormReady } from "./settingsForm";
import CustomerService from "@/service/CustomerService";
import UserService from "@/service/UserService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  customerService: null,
  userService: null,
  data: () => ({
    SalesExecutivesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    SalesExecutives: null,
    SalesExecutive: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    user: {},
    users: []
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.user = {};
      this.SalesExecutive = { active: true };
      this.SalesExecutivesForm = true;
    },
    openConfirmation(data) {
      this.SalesExecutive = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editSalesExecutives(data) {
      this.user = {};
      if (this.users && this.users[0]) {
        this.user = this.users.find(a => a.id === data.userId);
      }
      this.SalesExecutive = { ...data }; // SAL: edit a copy, not the list row
      this.SalesExecutivesForm = true;
    },
    async deleteSalesExecutive() {
      this.closeConfirmation();
      await this.customerService.deleteSalesExec(this.SalesExecutive.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Sales Executives removed",
        life: 5000
      });
      this.getAllSalesExecs();
      this.getAllActiveSalesExecsByHard();
    },
    save() {
      if (!settingFormReady(this, this.SalesExecutive, "salesExecName", "Name", "active")) return;
      let obj = { ...this.SalesExecutive }; // SAL: a copy, not the form/list row
      if (this.user && this.user.id) {
        obj.userId = this.user.id;
      }

      if (!this.SalesExecutive.id) {
        this.customerService
          .postSalesExec(obj)
          .then(res => {
            this.SalesExecutivesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Sales Executives added",
              life: 5000
            });
            this.getAllSalesExecs();
            this.getAllActiveSalesExecsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving sales exec",
              life: 5000
            });
          });
      } else {
        this.customerService
          .putSalesExec(obj, this.SalesExecutive.id)
          .then(res => {
            this.SalesExecutivesForm = false;
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Sales Executives updated",
              life: 5000
            });
            this.getAllSalesExecs();
            this.getAllActiveSalesExecsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating sales exec",
              life: 5000
            });
          });
      }
    },
    getAllSalesExecs() {
      this.loading = true;

      this.customerService
        .getAllSalesExecsByHard()
        .then(data => {
          this.SalesExecutives = data;
          this.loading = false;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting SalesExecutives",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "salesExecs"'
          });
        });
    },
    getAllActiveSalesExecsByHard() {
      this.customerService
        .getAllActiveSalesExecsByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeSalesExecs"'
          });
        });
    },
    getAllActiveUsers() {
      this.userService
        .getAllActiveUsers()
        .then(data => {
          this.users = data;
        })
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting users",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeUsers"'
          });
        });
    }
  },
  created() {
    this.customerService = new CustomerService();
    this.userService = new UserService();
  },
  mounted() {
    this.getAllSalesExecs();
    this.getAllActiveUsers();
  }
};
</script>
